<template>
    <div class="militaly">
        <!-- <el-divider ></el-divider> -->
        <img style="width: 100%;margin-bottom: 70px;margin-top: -8px;" src="../assets/横幅.png" alt="">
        <!-- <el-divider></el-divider> -->
        <img src="../assets/业务背景.png" alt="">
        <el-divider></el-divider>
        <!-- <img src="../assets/解决方案.png" alt="">
        <el-divider></el-divider> -->
        <img src="../assets/价值优势@1x.png" alt="">
        <el-divider></el-divider>
        <!-- <img src="../assets/应用场景.png" alt="">
        <el-divider></el-divider> -->
        <div style="display: flex;width: 420px;height:80px;margin: 0 auto;">
            <el-button @click="kaitong"
                style="border: none; color: white;border-radius: 8px;width:300px;text-align: center;font-size: 20px;margin-left: -1px;">开通产品</el-button>
            <el-button @click="zixun"
                style="border: none;color: white;border-radius: 8px;width:300px;text-align: center;font-size: 20px;">立即咨询</el-button>
        </div>
        <div style="margin-bottom: 100px;">
            <div style="width: 118px;margin: 0 auto;display: flex;">
                <p style="width: 12px;height:0.1px;border: 1px solid #3D3D3D;margin-top: 11px;opacity: 0.8;"></p>
                <p style="margin: 0 10px 0 10px;">操作指南</p>
                <p style="width: 12px;height:0.1px;border: 1px solid #3D3D3D;margin-top: 11px;opacity: 0.8;"></p>
            </div>
            <p style="display: block; width: 900px;margin: 20px auto;line-height: 40px;">
                已有明确融资需求的客户请直接点击“开通产品”并申请融资, 如需咨询或需要其他帮助，请点击“立即咨询”填写融资咨询信息，我们会尽快联系您</p>
        </div>

        <el-dialog style="border-bottom: 10px;" :visible.sync="dialogVisible" width="30%">
            <div
                style="font-size: 18px;color: white; height: 50px;background-color:#c49958;margin-top: -30px;line-height: 50px;">
                咨询信息填写</div>
            <el-form :model="form" style="margin-top: 15px;" ref="form">
                <el-form-item label="企业名称"  :label-width="formLabelWidth" prop="qzName" :rules="[
                    { required: true, message: '请输入企业名称', trigger: 'blur' },

                ]">
                    <el-input v-model="form.qzName" @keydown.native.space.prevent placeholder="请输入企业名称" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="联系人姓名" :label-width="formLabelWidth" prop="perName" :rules="[
                    { required: true, message: '请输入联系人姓名', trigger: 'blur' },

                ]">
                    <el-input v-model="form.perName" @keydown.native.space.prevent placeholder="请输入联系人姓名" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="联系电话" prop="perPhone" :rules="[
                    { required: true, message: '请输入联系人电话', trigger: 'blur' },
                    { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
                ]" :label-width="formLabelWidth">
                    <el-input v-model="form.perPhone" @keydown.native.space.prevent placeholder="请输入联系人电话" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="资金需求额度" :label-width="formLabelWidth" prop="needMoney" :rules="[
                    { required: true, message: '请输入资金额度', trigger: 'blur' },

                ]">
                    <el-input v-model="form.needMoney" @keydown.native.space.prevent type="number" placeholder="请输入资金额度" style="width: 72%;"
                        autocomplete="off"></el-input>
                    <span style="margin-left: 10px;">万元</span>
                </el-form-item>
                <el-form-item label="咨询内容" :label-width="formLabelWidth" prop="noticeContent" :rules="[
                    { required: true, message: '请填写咨询内容，字数不可超过100字', trigger: 'blur' },

                ]">
                    <el-input style="width: 80%;" @keydown.native.space.prevent type="textarea" :autosize="{ minRows: 2, maxRows: 3 }"
                        placeholder="请填写咨询内容，字数不可超过100字" maxlength="100" v-model="form.noticeContent">
                    </el-input>
                </el-form-item>

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button style="width:150px;background: white;color: black;" @click="dialogVisible = false">取
                    消</el-button>
                <el-button style="width:150px;color: white;" @click="dialogVisibleopen()">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog class="dists" width="21%" :visible.sync="dialogVisiblets">
            <div
                style="font-size: 18px;color: white; height: 35px;background-color:#c49958;margin-top: -30px;line-height: 35px;">
                提示框</div>
            <p style="font-size: 17px;margin-top: 45px;">您的咨询信息已提交，我们会尽快与您联系！</p>
            <el-button
                style="margin-top: 60px; width:100px;height: 35px;line-height: 10px;color:white; background-color:#c49958;"
                @click="dialogVisiblets = false">确 定</el-button>
        </el-dialog>
    </div>
</template>
<script>
import { consu, sys_notice_zx } from "../request/api.js"
export default {
    data() {
        return {
            dialogVisible: false,
            form: {
                // name: '',
                // region: '',
                // date1: '',
                // date2: '',
                // delivery: false,
                // type: [],
                // resource: '',
                // desc: ''
                qzName: '',
                perName: '',
                perPhone: '',
                needMoney: '',
                noticeContent: ''
            },
            formLabelWidth: '120px',
            dialogVisiblets: false,
            textarea2: ""
        }
    },
    methods: {
        zixun() {
            this.dialogVisible = true
        },
        dialogVisibleopen() {
            if (this.form.qzName == '') {
                this.$message.error('请填写企业名称！')
                return
            }
            if (this.form.perName == '') {
                this.$message.error('请填写联系人姓名！')
                return
            }
            if (this.form.perPhone == '') {
                this.$message.error('请填写联系电话！')
                return
            }
            if (this.form.needMoney == '') {
                this.$message.error('请填写资金需求！')
                return
            }
            if (this.form.noticeContent == '') {
                this.$message.error('请填写咨询内容！')
                return
            }

            this.$refs.form.validate((valid) => {
                if (valid) {

                    this.dialogVisible = false
                    let params = this.form;
                    this.form.typec = '2';
                    sys_notice_zx(params).then(res => {
                        if (res.code == 200) {
                            this.dialogVisiblets = true;
                            this.form.qzName = '';
                            this.form.perName = '';
                            this.form.perPhone = '';
                            this.form.needMoney = '';
                            this.form.noticeContent = '';
                        }
                    })

                } else {


                    return false;
                }
            })




        },
        kaitong() {
            window.open('http://www.cgwcrpt.com/#/register')
        },
    }
}
</script>
<style scoped lang="scss">
.militaly {

    margin: 71px auto;
    margin-bottom: 100px;

    .headimg {
        // width: 100%;
        // height: 800px;
    }
}

::v-deep .el-divider {
    width: 1111px;
    margin: 30px auto;
}

img {
    // width: 1111px;
    // height: auto;
}

.el-input {
    width: 80%;
}

.el-button {
    width: 200px;
    height: 50px;
    margin-left: 20px;
    background: linear-gradient(180deg, #DCB780 0%, #C49958 100%);
}

.el-button:nth-child(2) {
    margin-left: 50px;
}

.el-dialog__footer {
    width: 80%;
    margin: 0 auto;

    .el-button:nth-child(2) {
        margin-right: 40px;
    }
}

.dists ::v-deep .el-dialog {
    top: 20%;
    border-radius: 7px !important;
    height: 200px;
    line-height: 0px;
}

.dists ::v-deep .el-dialog .el-dialog__header {
    display: none
}

::v-deep .el-form-item__label:before {
    display: none;
}

::v-deep .el-form-item__error {
    margin-left: 44px;
}

::v-deep .el-dialog__body {
    padding: 0;
}

::v-deep .el-icon-close {
    display: none;
}
</style>